import React, { useEffect, useState } from 'react'
import './RelatedProducts.css'
import Item from '../Item/Item'
import { backend_url } from '../../App';

const RelatedProducts = ({ category, subcategory, id }) => {
  const [related, setRelated] = useState([]);

  useEffect(() => {
    fetch(`${backend_url}/relatedproducts`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ category, subcategory }), 
    })
      .then((res) => res.json())
      .then((data) => setRelated(data));
  }, [category, subcategory]);

  const handleItemClick = (itemId) => {
    // Prevent multiple reloads by using localStorage
    if (!localStorage.getItem("hasReloaded")) {
      // localStorage.setItem("hasReloaded", "true");
      setTimeout(() => {
        window.location.reload();
      }, 10); 
    }
  };


  return (
   <div className="relatedproducts">
      <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium text-center mb-6" 
          style={{ fontFamily: "'Times New Roman', Serif" }}>
        Related Products
      </h2>
      <hr />

      <div className="w-full max-w-screen-xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {related.map((item) => {
          if (id !== item.id) {
            const offerPrice = (item.old_price * (100 - item.new_price)) / 100;
            const discountPercentage = ((item.old_price - offerPrice) / item.old_price) * 100;

            return (
              <div key={item.id} onClick={() => handleItemClick(item.id)}>
                <Item
                  id={item.id}
                  name={item.name}
                  image={item.images?.[0] || ""}
                  new_price={offerPrice.toFixed(2)}
                  old_price={item.old_price}
                  discountPercentage={discountPercentage.toFixed(0)}
                  scale={item.scale}
                />
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default RelatedProducts;
